import React, { Component } from 'react'
import QRCodeReact from 'qrcode.react'

import * as api from '../../lib/api'
import { NavInTrack } from '../../components/nav'
import Page from '../page'
import './checks.css'
// https://github.com/SumiMakito/Awesome-qr.js/

// Métadonnées d'affichage par méthode de VALIDATION (check) — 0 ou 1 par point
const METHODS = {
  code: { label: 'Mot code', color: '#5bc0de' },
  qrcode: { label: 'QR Code', color: '#337ab7' },
  image: { label: 'Image', color: '#9b59b6' }
}

// Métadonnées d'affichage par méthode de DÉCLENCHEMENT (trigger) — 0..N par point
const TRIGGERS = {
  manual: { label: 'Au clic sur le point', color: '#777' },
  location: { label: "Par la position de l'utilisateur", color: '#5cb85c' },
  beacon: { label: 'Balise bluetooth', color: '#0275d8' }
}

export default class TrackChecks extends Component {
  state = {
    points: [],
    loaded: false,
    track: null,
    experience: null
  }

  componentDidMount() {
    const { trackUid, experienceUid } = this.props.match.params
    api.tracks
      .get(trackUid)
      .then(track => this.setState({ track }))
      .catch(() => {})
    api.experiences
      .get(experienceUid)
      .then(experience => this.setState({ experience }))
      .catch(() => {})
    api.points.getFrom('tracks', trackUid).then(points => {
      const promises = points.map(async point => {
        const check = point.check
        if (check && check.type === 'image' && check.target) {
          // `target` est un objet { name, resource, overlay } ; on supporte aussi
          // l'ancien format où target était directement un id de ressource.
          const targetId = typeof check.target === 'string' ? check.target : check.target.resource
          const overlayId = typeof check.target === 'string' ? null : check.target.overlay
          if (targetId) {
            check.targetResource = await api.resources.get(targetId).catch(() => null)
          }
          if (overlayId) {
            check.overlayResource = await api.resources.get(overlayId).catch(() => null)
          }
        }
        return point
      })
      Promise.all(promises).then(enrichedPoints => {
        const sorted = enrichedPoints.sort((a, b) => (a.order || 0) - (b.order || 0))
        this.setState({ points: sorted, loaded: true })
      })
    })
  }

  renderCheckContent(check) {
    const type = check.type

    if (type === 'code') {
      return (
        <div className="check-visual">
          <div className="check-field-label">Code à saisir</div>
          <div className="check-code" onClick={e => e.stopPropagation()}>
            {check.code || <span className="check-missing">non défini</span>}
          </div>
        </div>
      )
    }

    if (type === 'qrcode') {
      return (
        <div className="check-visual">
          {check.code ? (
            <>
              <QRCodeReact style={{ padding: '8px' }} value={check.code} size={150} level="M" />
              <div className="check-qrcode" onClick={e => e.stopPropagation()}>
                {check.code}
              </div>
            </>
          ) : (
            <span className="check-missing">aucun code défini</span>
          )}
        </div>
      )
    }

    if (type === 'image') {
      const target = check.target || {}
      const targetName = typeof target === 'object' ? target.name : null
      const { targetResource, overlayResource } = check
      return (
        <div className="check-visual">
          {targetResource ? (
            <img
              className="check-image"
              src={api.resources.getUrl(targetResource.hd?.file || targetResource.original?.file)}
              alt={targetName || ''}
            />
          ) : (
            <span className="check-missing">image cible manquante</span>
          )}
          {targetName && (
            <div style={{ marginTop: '8px' }}>
              <div className="check-field-label">Cible Vuforia</div>
              <div className="check-code" onClick={e => e.stopPropagation()}>
                {targetName}
              </div>
            </div>
          )}
          {overlayResource && (
            <div style={{ marginTop: '8px' }}>
              <div className="check-field-label">Image de remplacement</div>
              <img
                className="check-image overlay"
                src={api.resources.getUrl(overlayResource.hd?.file || overlayResource.original?.file)}
                alt=""
              />
            </div>
          )}
        </div>
      )
    }

    return null
  }

  renderTriggerDetail(trigger) {
    if (trigger.type === 'location' && trigger.distance != null) {
      return <span className="trigger-detail">{trigger.distance} m</span>
    }
    if (trigger.type === 'beacon' && (trigger.uuid || trigger.macAdress)) {
      return <span className="trigger-detail">{trigger.uuid || trigger.macAdress}</span>
    }
    return null
  }

  goToTrigger = pointId => {
    const { siteUid, experienceUid, trackUid } = this.props.match.params
    this.props.history.push(`/site/${siteUid}/experience/${experienceUid}/track/${trackUid}/point/${pointId}/trigger/`)
  }

  renderCard(point) {
    const check = point.check && point.check.type ? point.check : null
    const triggers = (point.triggers || []).filter(t => t && t.type)
    const method = check ? METHODS[check.type] : null

    return (
      <div
        className="check-card"
        key={point._id}
        onClick={() => this.goToTrigger(point._id)}
        title="Ouvrir le déclenchement du point"
      >
        <div className="check-card-header">
          <p className="check-card-name">{point.name || <span className="check-muted">Sans nom</span>}</p>
          {point.internalName && <div className="check-card-internal">Nom interne : {point.internalName}</div>}
        </div>
        <div className="check-card-body">
          <div className="check-section">
            {check && method ? (
              <>
                <div className="check-section-header">
                  <div className="check-section-title">Validation</div>
                  <span className="method-badge" style={{ backgroundColor: method.color }}>
                    {method.label}
                  </span>
                </div>
                {this.renderCheckContent(check)}
              </>
            ) : (
              <span className="check-muted">Aucune méthode de validation</span>
            )}
          </div>

          {triggers.length > 0 && (
            <div className="check-section">
              <div className="check-section-title">Déclenchement sans validation</div>
              <div className="trigger-badges">
                {triggers.map((trigger, i) => {
                  const meta = TRIGGERS[trigger.type] || { label: trigger.type, color: '#999' }
                  return (
                    <div className="trigger-badge" key={i}>
                      <span className="trigger-dot" style={{ backgroundColor: meta.color }} />
                      <span>{meta.label}</span>
                      {this.renderTriggerDetail(trigger)}
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  render() {
    const { points, loaded, track, experience } = this.state
    return (
      <Page>
        <NavInTrack />
        <div id="content">
          <div className="checks">
            {points.length > 0 && (
              <div className="checks-toolbar">
                <button className="btn btn-primary" onClick={() => window.print()}>
                  <span className="glyphicon glyphicon-print" /> Imprimer / exporter en PDF
                </button>
              </div>
            )}
            <div className="checks-print-title">
              {experience && experience.name && <div className="checks-print-experience">{experience.name}</div>}
              <div className="checks-print-track">
                Validation des points du parcours{track && track.name ? ` ${track.name}` : ''}
              </div>
            </div>
            {loaded && points.length === 0 && <div className="checks-empty">Aucun point dans ce parcours.</div>}
            {points.length > 0 && (
              <>
                <div className="checks-grid">{points.map(point => this.renderCard(point))}</div>
              </>
            )}
          </div>
        </div>
        <div id="app-preview" />
      </Page>
    )
  }
}
